// English translations
const common = {
  // Navbar
  "nav.home": "Home",
  "nav.generator": "AI Generator",
  "nav.pricing": "Pricing",
  "nav.login": "Login / Sign Up",
  "nav.startFree": "Start Creating Free",
  "nav.memberCenter": "Member Center",
  "nav.logout": "Logout",

  // Hero Section
  "hero.badge": "100% Free Forever • No Login Required",
  "hero.title1": "Free AI Image",
  "hero.title2": "Generator",
  "hero.subtitle": "Transform your ideas into stunning visuals instantly with AI.\nNo registration, unlimited generations, completely free.",
  "hero.ctaPrimary": "Start Creating Free",
  "hero.ctaSecondary": "See How It Works",
  "hero.trust1": "No Credit Card",
  "hero.trust2": "Unlimited Use",
  "hero.trust3": "Commercial Rights",

  // Features Section
  "features.badge": "Features",
  "features.title": "Powerful AI Image Generation",
  "features.subtitle": "Experience next-generation AI image creation with cutting-edge features designed for creators",
  "features.f1.title": "Text to Image",
  "features.f1.desc": "Transform your words into stunning visuals with advanced AI models. Simply describe what you want to see.",
  "features.f2.title": "Image to Image",
  "features.f2.desc": "Upload any image and transform it into different styles, enhance quality, or create variations instantly.",
  "features.f3.title": "Style Transfer",
  "features.f3.desc": "Apply artistic styles to your images. From realistic to anime, oil painting to digital art.",
  "features.f4.title": "Lightning Fast",
  "features.f4.desc": "Generate professional-quality images in seconds with our optimized AI infrastructure.",
  "features.f5.title": "Privacy Protected",
  "features.f5.desc": "Zero data retention policy. Your prompts and images are never stored on our servers.",
  "features.f6.title": "Unlimited & Free",
  "features.f6.desc": "No usage limits, no credit cards, no registration required. Create as much as you want, forever.",

  // Gallery Section
  "gallery.badge": "Gallery",
  "gallery.title": "Get Inspired",
  "gallery.subtitle": "Explore stunning AI-generated images created by our community",
  "gallery.cta": "Create Your Own",
  "gallery.clickToUse": "Click to use",
  "gallery.copyPrompt": "Copy Prompt",
  "gallery.copied": "Copied!",
  "gallery.usePrompt": "Use This",
  "gallery.hoverTip": "Hover over any image to copy or use its prompt",

  // Stats Section
  "stats.title": "Trusted by Millions",
  "stats.subtitle": "Join the world's largest free AI image generator community",
  "stats.s1.label": "Active Users",
  "stats.s1.value": "3M+",
  "stats.s1.desc": "Monthly active users",
  "stats.s2.label": "Images Created",
  "stats.s2.value": "1,530",
  "stats.s2.desc": "Images generated per minute",
  "stats.s3.label": "User Rating",
  "stats.s3.value": "4.9",
  "stats.s3.desc": "Average quality rating",

  // Testimonials Section
  "testimonials.badge": "Testimonials",
  "testimonials.title": "What Creators Say",
  "testimonials.subtitle": "See how creators use our AI to boost productivity",
  "testimonials.ratings": "Based on 25,017+ user ratings, average 4.9/5 stars",
  "testimonials.t1.name": "Sophie Miller",
  "testimonials.t1.role": "Freelance Designer",
  "testimonials.t1.content": "This AI image generator has increased my creative efficiency by 10x! The image quality is beyond imagination and perfectly meets commercial requirements.",
  "testimonials.t2.name": "Michael Chen",
  "testimonials.t2.role": "Creative Director",
  "testimonials.t2.content": "With the advanced features, I can precisely control every detail. This is the most powerful AI image generator on the market!",
  "testimonials.t3.name": "Sarah Wang",
  "testimonials.t3.role": "E-commerce Manager",
  "testimonials.t3.content": "As an e-commerce manager, this tool helps me quickly generate product showcase images. The results are far better than other AI tools!",
  "testimonials.t4.name": "David Liu",
  "testimonials.t4.role": "Brand Designer",
  "testimonials.t4.content": "The editor allows me to maintain brand style consistency. This AI image generator truly understands my needs.",
  "testimonials.t5.name": "Emma Zhang",
  "testimonials.t5.role": "Content Creator",
  "testimonials.t5.content": "The speed is amazing! Professional-quality images generated in seconds, greatly shortening project cycles.",
  "testimonials.t6.name": "Kevin Wu",
  "testimonials.t6.role": "Game Concept Artist",
  "testimonials.t6.content": "The detail performance is unparalleled. As a game developer, this has become our go-to tool for concept design.",

  // CTA Section
  "cta.title1": "Ready to Create",
  "cta.title2": "Amazing AI Art?",
  "cta.subtitle": "Join millions of creators using the world's most powerful free AI image generator",
  "cta.button": "Generate Your First Image Free",
  "cta.note": "No credit card required • No signup • Unlimited generations",

  // FAQ Section
  "faq.badge": "FAQ",
  "faq.title": "Frequently Asked Questions",
  "faq.contact": "Have more questions? Contact us at support@aiimagegenrator.com",
  "faq.q1": "What is this AI Image Generator and how does it work?",
  "faq.a1": "Our AI Image Generator is the world's first completely free, unlimited AI image creation tool. It uses advanced AI models to create high-quality images from text descriptions, with no registration or usage limits required.",
  "faq.q2": "Is this AI Image Generator really free to use?",
  "faq.a2": "Yes, our AI Image Generator is completely free to use! We are committed to being the world's largest and most powerful free AI image generator. No hidden fees, no credit cards, and no usage limits.",
  "faq.q3": "What makes this different from other AI image generators?",
  "faq.a3": "Our AI Image Generator is the only platform offering unlimited free usage with intelligent routing across multiple AI models. We provide superior image quality, fast generation speeds, and complete privacy protection, all at no cost and without registration requirements.",
  "faq.q4": "Do I need to create an account to use this?",
  "faq.a4": "No account needed! Our AI Image Generator lets you visit and start generating images immediately. We believe in making AI accessible without any barriers.",
  "faq.q5": "What types of images can I create?",
  "faq.a5": "Our AI Image Generator allows you to create various types of images including realistic scenes, artistic illustrations, digital art, anime-style images, and more.",
  "faq.q6": "How does this protect my privacy?",
  "faq.a6": "We take privacy very seriously. We do not store your prompts or generated images on our servers, and we don't require any personal information. Your creations remain completely confidential.",
  "faq.q7": "Can I use the generated images for commercial purposes?",
  "faq.a7": "Yes, you own the rights to images generated using our AI Image Generator. You can use them for both personal and commercial purposes, making it perfect for creators and businesses.",
  "faq.q8": "Is this available on mobile devices?",
  "faq.a8": "Currently, you can access our AI Image Generator through our website, which works well on mobile browsers. We are actively developing dedicated mobile apps to provide an even better experience.",

  // Pricing Section
  "pricing.title": "Simple, Transparent Pricing",
  "pricing.subtitle": "Completely free, no payment required, enjoy all features",
  "pricing.monthly": "Monthly",
  "pricing.yearly": "Yearly",
  "pricing.save17": "Save 17%",
  "pricing.popular": "MOST POPULAR",
  "pricing.guarantee": "30-Day Money Back Guarantee",
  "pricing.loginPrompt": "Please log in first to upgrade to Pro",
  "pricing.free.name": "Completely Free",
  "pricing.free.desc": "Free access to all AI image generation features forever",
  "pricing.free.cta": "Start Using Free Now",
  "pricing.free.f1": "Unlimited image generation",
  "pricing.free.f2": "High quality output (1024x1024)",
  "pricing.free.f3": "All styles & filters",
  "pricing.free.f4": "No login required",
  "pricing.free.f5": "No watermarks",
  "pricing.free.f6": "Fast generation speed",
  "pricing.pro.name": "Pro",
  "pricing.pro.desc": "For professionals and content creators",
  "pricing.pro.cta": "Upgrade to Pro",
  "pricing.pro.f1": "Unlimited images",
  "pricing.pro.f2": "High quality (1024x1024)",
  "pricing.pro.f3": "Premium styles & filters",
  "pricing.pro.f4": "Priority support",
  "pricing.pro.f5": "No watermarks",
  "pricing.pro.f6": "Fast generation speed",
  "pricing.pro.f7": "Batch generation (up to 10)",
  "pricing.pro.f8": "Commercial license",
  "pricing.pro.f9": "Advanced AI models",
  "pricing.pro.f10": "Image upscaling",
  "pricing.pro.saveYear": "Save $30/year",
  "pricing.paypalCheckout": "Complete your subscription via PayPal",
  "pricing.cancelPayment": "Cancel",
  "pricing.subscriptionSuccess": "Subscription successful! Welcome to Pro!",

  // Comparison Table
  "compare.title": "Detailed Comparison",
  "compare.subtitle": "See what's included in each plan",
  "compare.feature": "Feature",
  "compare.free": "Free",
  "compare.pro": "Pro",
  "compare.f1": "Image Generations",
  "compare.v1.free": "Unlimited",
  "compare.v1.pro": "Unlimited",
  "compare.f2": "Max Resolution",
  "compare.v2.free": "1024x1024",
  "compare.v2.pro": "4096x4096",
  "compare.f3": "Generation Speed",
  "compare.v3.free": "Standard",
  "compare.v3.pro": "3x Faster",
  "compare.f4": "Batch Generation",
  "compare.v4.free": "5 images",
  "compare.v4.pro": "20 images",
  "compare.f5": "Style Options",
  "compare.v5.free": "Basic",
  "compare.v5.pro": "Advanced",
  "compare.f6": "Editing Tools",
  "compare.v6.free": "Basic",
  "compare.v6.pro": "Advanced",
  "compare.f7": "Ads",
  "compare.v7.free": "Yes",
  "compare.v7.pro": "No",
  "compare.f8": "Priority Support",
  "compare.v8.free": "No",
  "compare.v8.pro": "Yes",
  "compare.f9": "Commercial License",
  "compare.v9.free": "Yes",
  "compare.v9.pro": "Yes",
  "compare.f10": "Watermark",
  "compare.v10.free": "No",
  "compare.v10.pro": "No",

  // Generator Page
  "gen.title": "AI Image Generator",
  "gen.subtitle": "Create stunning images with AI - Free, unlimited, no login required",
  "gen.mode": "Generation Mode",
  "gen.textToImage": "Text to Image",
  "gen.imageToImage": "Image to Image",
  "gen.aspectRatio": "Aspect Ratio",
  "gen.style": "Style",
  "gen.style.none": "No Style",
  "gen.style.realistic": "Realistic",
  "gen.style.anime": "Anime",
  "gen.style.artistic": "Artistic",
  "gen.style.digital": "Digital Art",
  "gen.promptLabel": "Describe what you want to create",
  "gen.promptPlaceholder": "A beautiful sunset over mountains with vibrant colors...",
  "gen.promptTip": "💡 Tip: Be specific and descriptive for best results",
  "gen.uploadLabel": "Upload Source Image",
  "gen.uploadHint": "Click to upload or drag and drop",
  "gen.uploadSize": "PNG, JPG up to 10MB",
  "gen.generateBtn": "Generate Image",
  "gen.free": "Free",
  "gen.resultPlaceholder": "Your generated image will appear here",
  "gen.emptyPrompt": "Please enter a prompt to generate an image",
  "gen.promptPrefilled": "✨ Prompt filled from gallery! Click Generate to create your image.",
  "gen.clearPrompt": "Clear",

  // Generator Tabs & New Keys
  "gen.tabSingle": "Single Image",
  "gen.tabBatch": "Batch Generate",
  "gen.tabHistory": "History",
  "gen.successMsg": "Image generated successfully!",
  "gen.generating": "Generating...",
  "gen.download": "Download Image",
  "gen.new": "New",

  // Image History
  "history.title": "Generation History",
  "history.empty": "No images generated yet",
  "history.emptyHint": "Your generated images will appear here",
  "history.clearAll": "Clear All",
  "history.clearConfirmTitle": "Clear All History?",
  "history.clearConfirmDesc": "This will permanently delete all your generation history. This action cannot be undone.",
  "history.cancel": "Cancel",
  "history.clearConfirm": "Clear All",
  "history.reuse": "Use This Prompt",
  "history.download": "Download",
  "history.copyPrompt": "Copy Prompt",
  "history.justNow": "Just now",
  "history.minutesAgo": "{{count}}m ago",
  "history.hoursAgo": "{{count}}h ago",
  "history.daysAgo": "{{count}}d ago",

  // Batch Generation
  "batch.title": "Batch Generation",
  "batch.badge": "Pro Feature",
  "batch.countLabel": "Number of images to generate",
  "batch.images": "images",
  "batch.generateBtn": "Generate {{count}} Images",
  "batch.generating": "Generating",
  "batch.progressText": "{{done}} of {{total}} images completed",
  "batch.results": "Generated Images",
  "batch.downloadAll": "Download All",
  "batch.hint": "Enter a prompt on the left, then generate multiple variations at once",

  // Image to Video
  "gen.tabI2V": "Image to Video",
  "i2v.title": "Image to Video",
  "i2v.uploadTitle": "Upload or paste an image",
  "i2v.uploadHint": "Click to upload, drag & drop, or Ctrl+V to paste",
  "i2v.uploadFormats": "PNG, JPG, WebP up to 20MB",
  "i2v.changeImage": "Change",
  "i2v.effectLabel": "Motion Effect",
  "i2v.effectZoomIn": "Zoom In",
  "i2v.effectZoomOut": "Zoom Out",
  "i2v.effectPanLeft": "Pan Left",
  "i2v.effectPanRight": "Pan Right",
  "i2v.effectPanUp": "Pan Up",
  "i2v.generateBtn": "Generate Video",
  "i2v.generating": "Generating",
  "i2v.progressHint": "Rendering frames, please wait...",
  "i2v.success": "Video generated successfully!",
  "i2v.download": "Download Video",
  "i2v.regenerate": "Try Again",
  "i2v.error": "Video generation failed. Please try again.",
  "i2v.invalidFile": "Please select a valid image file.",
  "i2v.fileTooLarge": "File is too large. Max 20MB.",

  // Guest Banner
  "guest.remaining": "Guest Free Trial: {{remaining}}/5 remaining",
  "guest.exhausted": "Free trial used up. Please log in to continue",
  "guest.loginToUnlock": "Log in to unlock unlimited generation",
  "guest.loginButton": "Login / Sign Up",
  "guest.welcomeBack": "Welcome back, {{name}}! All generation features are unlocked.",

  // Footer
  "footer.stayUpdated": "Stay Updated",
  "footer.newsletter": "Get the latest updates on new features and AI image generation tips",
  "footer.emailPlaceholder": "Your email address",
  "footer.subscribe": "Subscribe",
  "footer.product": "Product",
  "footer.features": "Features",
  "footer.company": "Company",
  "footer.legal": "Legal",
  "footer.aiGenerator": "AI Generator",
  "footer.pricing": "Pricing",
  "footer.textToImage": "Text to Image",
  "footer.imageToImage": "Image to Image",
  "footer.styleTransfer": "Style Transfer",
  "footer.aboutUs": "About Us",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.copyright": "© 2025 AI Image Generator. All rights reserved.",
  "footer.poweredBy": "Powered by Readdy",

  // Pro Banner
  "proBanner.badge": "LIMITED TIME OFFER",
  "proBanner.title": "Unlock Pro for Ultimate Creative Power",
  "proBanner.subtitle": "Get 4K resolution, 3x faster generation, batch processing, and zero ads. Take your AI art to the next level.",
  "proBanner.f1": "3x Faster",
  "proBanner.f2": "4K Resolution",
  "proBanner.f3": "Batch Generate",
  "proBanner.f4": "No Ads",
  "proBanner.discount": "Save 48% — Limited Time",
  "proBanner.cta": "Upgrade to Pro Now",
  "proBanner.guarantee": "30-day money back guarantee",

  // Member Center
  "member.loginRequired": "Login Required",
  "member.loginDesc": "Please log in to access your Member Center and manage your subscription.",
  "member.backHome": "Back to Home",
  "member.freePlan": "Free Plan",
  "member.proPlan": "Pro Plan",
  "member.currentPlan": "Current Plan",
  "member.planType": "Plan Type",
  "member.freePlanLabel": "Free",
  "member.resolution": "Max Resolution",
  "member.speed": "Generation Speed",
  "member.speedStandard": "Standard",
  "member.speed3x": "3x Faster",
  "member.batch": "Batch Generation",
  "member.batch5": "Up to 5",
  "member.batch20": "Up to 20",
  "member.watermark": "Watermark",
  "member.noWatermark": "No Watermark",
  "member.hasWatermark": "Yes",
  "member.usageStats": "Usage Statistics",
  "member.todayUsage": "Today\\'s Usage",
  "member.totalGenerated": "Total Generated",
  "member.memberSince": "Member Since",
  "member.upgradeTitle": "Upgrade to Pro for the Full Experience",
  "member.upgradeDesc": "Unlock 4K resolution, 3x faster speed, batch generation, no watermarks, and no ads.",
  "member.upgradeCta": "Upgrade to Pro",
  "member.proBenefits": "Your Pro Benefits",
  "member.benefit1": "Unlimited Images",
  "member.benefit2": "4K Resolution",
  "member.benefit3": "3x Faster Speed",
  "member.benefit4": "Batch Generation",
  "member.benefit5": "No Ads",
  "member.benefit6": "Commercial License",
};

export default common;
